<template>
  <v-toolbar class="main-nav escalon-bb primary" height="54">
    <v-app-bar-nav-icon class="hidden-md-and-up"></v-app-bar-nav-icon>
    <v-text-field
      v-model="searchText"
      @keyup.enter="submitQuickSearch(searchText)"
      single-line
      hide-details
      light
      solo
      placeholder="Quick Search"
      class="quick-search text-xs-center"
      v-if="!ssoEmrPro">
    </v-text-field>
    <image-button
      btnClass="advanced-search-btn"
      icon
      @click="submitQuickSearch(searchText)"
      :image="coloredAssetUrls.advancedSearch"
      v-if="!ssoEmrPro" />
    <v-btn text @click="openAdvancedSearch" v-if="!ssoEmrPro">Advanced</v-btn>
    <span v-if="ssoEmrPro">EMRPRO</span>
    <v-btn text @click="getPatients">Refresh</v-btn>
    <v-spacer></v-spacer>
    <router-link to="/patients">
      <img
        class="axis-logo"
        :src="require('../../assets/' + coloredLogo)" />
    </router-link>
    <div class="welcome-text">
      <span class="welcome-user-name">Welcome {{ userFullName }}</span>
      <br />
      <span class="welcome-user-practice">{{ this.axisTitle }}</span>
    </div>
    <v-menu offset-y :nudge-width="150">
      <template v-slot:activator="{ on }">
        <image-button v-on="on" icon :image="coloredAssetUrls.dropdown" />
      </template>
      <v-list>
        <v-list-item @click="toggleFullscreen">
          <v-list-item-title>View in Full Screen</v-list-item-title>
        </v-list-item>
        <v-list-item v-if="userIsAdmin" to="/adminpanel">
          <v-list-item-title>Administration Center</v-list-item-title>
        </v-list-item>
        <v-list-item v-if="!hideUserPref" @click="$emit('userPrefs')">
          <v-list-item-title>User Preferences</v-list-item-title>
        </v-list-item>
        <v-list-item @click="openHelpDialog">
          <v-list-item-title>Knowledge Center</v-list-item-title>
        </v-list-item>
        <v-list-item @click="logout">
          <v-list-item-title>Logout</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-toolbar>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import imageButton from "../controls/ImageButton";

export default {
  name: "NavBar",
  components: { imageButton },
  data() {
    return {
      isFullscreen: false,
      searchText: "",
    };
  },
  computed: {
    ...mapGetters([
      "userFullName",
      "userIsAdmin",
      "hideUserPref",
      "axisTitle",
      "ssoEmrPro",
      "searchKeyword",
      "isIE",
      "userPrefs"
    ])
  },
  methods: {
    ...mapActions(["submitQuickSearch", "getPatients", "openHelpDialog"]),
    ...mapMutations([
      "openAdvancedSearch",
      "toggleFullscreen",
    ]),
    logout() {
      if (this.isIE) {
        this.$store.dispatch("logout");
        setTimeout(() => this.$router.push("/login"), 200);
      }
      else
        this.$store.dispatch("logout").then(() => this.$router.push("/login"));
    },
  },
  watch: {
    searchKeyword() {
      this.searchText = this.searchKeyword;
    }
  }
};
</script>

<style lang="scss" scoped>
.main-nav {
  height: $navbar-height;
  overflow: hidden;

  .quick-search.v-text-field--solo {
    max-width: 250px;

    .v-input__control {
      max-height: 45px;
      min-height: 0;

      .v-input__slot {
        border-radius: 30px;

        input {
          text-align: center;
        }
      }
    }
  }
  .axis-logo {
    width: 161px;
    margin-right: 40px;
  }

  .welcome-user-practice {
    text-transform: uppercase;
  }
}
</style>
<style scoped>
.v-list__tile__title {
  text-align: right;
}
</style>
